// extracted by mini-css-extract-plugin
export default {"faq-container":"CSXvkC","faqContainer":"CSXvkC","faq-title-container":"aSDeGN","faqTitleContainer":"aSDeGN","faq-title":"bSiR8z","faqTitle":"bSiR8z"};